"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRegistryManifest = void 0;
var editor_elements_conventions_1 = require("@wix/editor-elements-conventions");
var libraryManifestBuilder_1 = require("./builders/libraryManifestBuilder");
function addComponentModels(hostBuilder, _a) {
    var componentName = _a.componentName, model = _a.model;
    var componentBuilder = hostBuilder.getComponentBuilder(componentName);
    if (model.js) {
        componentBuilder.addUrl(model.id, model.js);
    }
    if (model.css) {
        componentBuilder.addStyleAsset(model.css);
    }
}
function addBatchPart(hostBuilder, _a) {
    var componentName = _a.componentName, part = _a.part, model = _a.model;
    var componentBuilder = hostBuilder.getComponentBuilder(componentName);
    /**
     * remove all prev. added assets that leads to the default part bundle
     */
    componentBuilder.filterAssets(function (asset) { return asset.part !== part; });
    if (model.js) {
        componentBuilder.addPart(model.id, part, model.js, true);
    }
    if (model.css) {
        componentBuilder.addStyleAsset(model.css, part);
    }
}
function parseRegistryManifest(_a) {
    var topology = _a.topology, manifest = _a.manifest;
    var baseURL = manifest.baseURL.endsWith('/')
        ? manifest.baseURL
        : manifest.baseURL + "/";
    var libraryBuilder = libraryManifestBuilder_1.createLibraryManifestBuilder({
        topology: topology,
    });
    var buildComponentId = function (componentName, part) {
        return editor_elements_conventions_1.getBundleId({
            componentName: componentName,
            part: part,
            namespace: manifest.namespace,
            host: manifest.host,
        });
    };
    var buildBatchId = function (batch) {
        return editor_elements_conventions_1.getBundleId({
            batch: batch,
            namespace: manifest.namespace,
            host: manifest.host,
        });
    };
    var buildSharedChunkId = function (part) {
        return editor_elements_conventions_1.getBundleId({
            part: part,
            namespace: manifest.namespace,
            host: manifest.host,
        });
    };
    var buildURL = function (id, hash) {
        if (!hash || !id) {
            return undefined;
        }
        return "" + baseURL + id + "." + hash;
    };
    if (manifest.environment) {
        if (manifest.environment.runtime) {
            libraryBuilder.addWebpackRuntimeBundle(buildURL('webpack-runtime', manifest.environment.runtime));
        }
        if (manifest.environment.hot) {
            libraryBuilder.addHotBundle(buildURL('hot', manifest.environment.hot));
        }
    }
    var hostBuilder = libraryBuilder.getHostBuilder(manifest.host);
    if (manifest.statics) {
        var statics_1 = manifest.statics;
        Object.keys(statics_1).forEach(function (componentName) {
            hostBuilder.addComponentStatics(componentName, statics_1[componentName]);
        });
    }
    if (manifest.model) {
        var _b = manifest.model, modelHash = _b[0], stylesHash = _b[1];
        var id = editor_elements_conventions_1.getBundleId({
            namespace: manifest.namespace,
            host: manifest.host,
        });
        var modelURL = buildURL(id, modelHash);
        var stylesURL = buildURL(id, stylesHash);
        if (modelURL) {
            hostBuilder.addUrl(id, modelURL);
        }
        if (stylesURL) {
            hostBuilder.addStyleAsset(stylesURL);
        }
    }
    if (manifest.shared) {
        var shared_1 = manifest.shared;
        Object.keys(shared_1).forEach(function (name) {
            var _a = shared_1[name], modelHash = _a[0], stylesHash = _a[1];
            var id = buildSharedChunkId(name);
            var modelURL = buildURL(id, modelHash);
            var stylesURL = buildURL(id, stylesHash);
            if (modelURL) {
                hostBuilder.addSharedChunkModel(name, id, modelURL);
            }
            if (stylesURL) {
                hostBuilder.addSharedChunkStyleAsset(name, stylesURL);
            }
        });
    }
    if (manifest.assets) {
        var assets = manifest.assets;
        assets.forEach(function (asset) {
            var type = asset[0], url = asset[1];
            if (url && type) {
                var assetsURL = "" + baseURL + url;
                /**
                 * TODO: probably we should completely remove extensions
                 */
                var extension = url.split('.').pop();
                libraryBuilder.addLibraryAsset(assetsURL, type, extension);
            }
        });
    }
    if (manifest.components) {
        var components_1 = manifest.components;
        Object.keys(components_1).forEach(function (componentName) {
            var _a = components_1[componentName], modelHash = _a[0], stylesHash = _a[1];
            var id = buildComponentId(componentName);
            addComponentModels(hostBuilder, {
                componentName: componentName,
                model: {
                    id: id,
                    js: buildURL(id, modelHash),
                    css: buildURL(id, stylesHash),
                },
            });
        });
    }
    if (manifest.parts) {
        var parts_1 = manifest.parts;
        Object.keys(parts_1).forEach(function (componentName) {
            Object.keys(parts_1[componentName]).forEach(function (part) {
                var componentBuilder = hostBuilder.getComponentBuilder(componentName);
                var _a = parts_1[componentName][part], modelHash = _a[0], stylesHash = _a[1];
                var id = buildComponentId(componentName, part);
                var modelURL = buildURL(id, modelHash);
                var stylesURL = buildURL(id, stylesHash);
                if (modelURL) {
                    componentBuilder.addPart(id, part, modelURL);
                }
                if (stylesURL) {
                    componentBuilder.addStyleAsset(stylesURL, part);
                }
            });
        });
    }
    if (manifest.batches) {
        var batches = manifest.batches;
        Object.entries(batches).forEach(function (_a) {
            var batchId = _a[0], batch = _a[1];
            var id = buildBatchId(batchId);
            var _b = batch.url, modelHash = _b[0], stylesHash = _b[1];
            var modelURL = buildURL(id, modelHash);
            var stylesURL = buildURL(id, stylesHash);
            if (batch.parts && batch.parts.length) {
                batch.parts.forEach(function (_a) {
                    var part = _a[0], components = _a.slice(1);
                    components.forEach(function (componentName) {
                        addBatchPart(hostBuilder, {
                            componentName: componentName,
                            part: part,
                            model: {
                                id: id,
                                js: modelURL,
                                css: stylesURL,
                            },
                        });
                    });
                });
            }
            batch.components.forEach(function (componentName) {
                addComponentModels(hostBuilder, {
                    componentName: componentName,
                    model: {
                        id: id,
                        js: buildURL(id, modelHash),
                        css: buildURL(id, stylesHash),
                    },
                });
                if (batch.parts && batch.parts.length) {
                    batch.parts.forEach(function (_a) {
                        var part = _a[0];
                        addBatchPart(hostBuilder, {
                            componentName: componentName,
                            part: part,
                            model: {
                                id: id,
                                js: modelURL,
                                css: stylesURL,
                            },
                        });
                    });
                }
            });
        });
    }
    return libraryBuilder.build();
}
exports.parseRegistryManifest = parseRegistryManifest;
//# sourceMappingURL=parseRegistryManifest.js.map